import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div
        className="hidden lg:flex flex-col justify-between p-12 relative bg-primary"
        style={{
          backgroundImage:
            "linear-gradient(rgba(29,78,216,0.82), rgba(29,78,216,0.82)), url('https://images.unsplash.com/photo-1550602883-4c2d2c705db2?q=85&w=1600&auto=format&fit=crop')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <img src="/elva-logo.png" alt="Elva Group" className="h-9 w-auto self-start" data-testid="login-logo" />
        <div>
          <h1 className="font-heading text-white text-4xl font-semibold leading-tight tracking-tight">
            Financial Planning
          </h1>
          <p className="text-primary-foreground/80 mt-5 text-base max-w-md leading-relaxed">
            Monthly operational forecasting, revenue planning and group financial
            management — one number, across every company.
          </p>
        </div>
        <span className="text-primary-foreground/70 text-sm">© 2026 Elva Group</span>
      </div>

      <div className="flex items-center justify-center bg-background px-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="font-heading text-2xl font-semibold text-foreground tracking-tight">Sign in</h2>
          <p className="text-sm text-muted-foreground mt-1 mb-8">Enter your credentials to continue</p>

          <div className="space-y-5">
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-sm font-medium text-slate-800">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                placeholder="you@elva-group.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-10"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-sm font-medium text-slate-800">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-10"
              />
            </div>
            {error && (
              <div className="text-sm text-[#B91C1C] bg-[#FEF2F2] border border-[#FECACA] rounded-md px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}
            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-10 bg-primary hover:bg-[#0047B3] text-white font-semibold"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
